import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser'
import { ModalResponseCodes } from '../modal.service';

export interface ErrorData {
    title: string,
    message: string,
    detailed: string
}

@Component({
    selector: 'error-modal',
    templateUrl: './error.html',
    styleUrls: ['../modal/modal.scss'],
    host: {
        class: 'st-error'
    },
    encapsulation: ViewEncapsulation.None
})
export class ErrorModal {
    @Input() public title: string = "Error";
    @Input() public message: any = "Message";
    @Input() public detailed: string = "";
    @Input() public continue: string = "Continue";

    constructor(
        public dialogRef: MatDialogRef<ErrorModal>,
        @Inject(MAT_DIALOG_DATA) public data: ErrorData
    ) {
        this.title = data.title;
        this.message = data.message;
        this.detailed = data.detailed;
    }

    onContinueClick(): void {
        this.dialogRef.close(ModalResponseCodes.OK);
    }
}



